import { AfterViewInit, Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { AODADialog } from '@core/utilities/aoda-dialog';
import { BaseComponent } from '@shared/components/base.component';
import { DialogData } from '@shared/components/confirmation-dialog/DialogData';
import { ValidationFunctions } from '@shared/validators/validation-functions';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { FormConfigDirective } from '../../../shared/directives/form-config.directive';
import { AutofocusByContentDirective } from '../../../shared/directives/autofocus-by-content.directive';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-copy-worksheet-dialog',
  templateUrl: './copy-worksheet-dialog.component.html',
  styleUrls: ['./copy-worksheet-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    FormConfigDirective,
    MatInput,
    AutofocusByContentDirective,
    MatError,
    MatDialogActions,
    MatButton,
    AsyncPipe,
    TranslatePipe
  ]
})
export class CopyWorksheetDialogComponent extends BaseComponent implements OnInit, AfterViewInit {
  data: any;
  f: UntypedFormGroup;
  srcWorksheetName: string;

  constructor(
    private readonly injector: Injector,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: DialogData,
    private readonly dialogRef: MatDialogRef<CopyWorksheetDialogComponent>
  ) {
    super(injector);
    this.data = data;
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.srcWorksheetName = this.data?.worksheet?.name;
    this.buildForm();
  }

  ngAfterViewInit(): void {
    AODADialog.applyAllFixes();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  copyWorksheet(): void {
    if (this.f.invalid) {
      return;
    }

    let worksheetName = this.worksheetName?.value?.trim();
    if (!worksheetName) {
      return;
    }

    this.data.worksheet.name = worksheetName;
    this.dialogRef.close(this.data.worksheet);
  }

  private buildForm(): void {
    this.f = this.formBuilder.group({
      worksheetName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30), ValidationFunctions.empty]]
    });
  }

  get worksheetName(): UntypedFormGroup {
    return this.f.get('worksheetName') as UntypedFormGroup;
  }
}
